/**
 * Servicio para interactuar con la API de Verificadora
 * Este servicio implementa los métodos necesarios para gestionar los pedidos de secuestro
 * según la documentación proporcionada.
 */
import apiClient from '@/plugins/axios';

// URL base para los endpoints de la API de Verificadora
const BASE_URL = 'verificadora';

/**
 * Servicio de Verificadora
 */
const verificadoraService = {
  /**
   * Obtiene todos los pedidos de secuestro activos
   * @returns {Promise} - Promesa con la lista de pedidos de secuestro
   */
  getAllPedidos() {
    return apiClient.post(`${BASE_URL}/consulta`);
  },

  /**
   * Obtiene un pedido de secuestro por su ID
   * @param {number} id - ID del pedido de secuestro
   * @returns {Promise} - Promesa con los datos del pedido de secuestro
   */
  getPedidoById(id) {
    return apiClient.get(`${BASE_URL}/getVerificadoraById`, { params: { id } });
  },

  /**
   * Crea un nuevo pedido de secuestro
   * @param {Object} pedido - Datos del pedido de secuestro
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  createPedido(pedido) {
    return apiClient.post(`${BASE_URL}/`, pedido);
  },

  /**
   * Actualiza un pedido de secuestro existente
   * @param {Object} pedido - Datos del pedido de secuestro con ID
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  updatePedido(pedido) {
    return apiClient.put(`${BASE_URL}/updateVerificadora`, pedido);
  },

  /**
   * Elimina (desactiva) un pedido de secuestro
   * @param {number} id - ID del pedido de secuestro
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  deletePedido(id) {
    return apiClient.delete(`${BASE_URL}/deleteVerificadora`, { params: { id } });
  },

  /**
   * Envía registros pendientes al sistema de Mendoza
   * @returns {Promise} - Promesa con el resultado del proceso de envío
   */
  enviarRegistrosMendoza() {
    return apiClient.get(`${BASE_URL}/enviarRegistroMendoza`);
  }
};

export default verificadoraService;
